<template>
  <div class="carousel-wrapper">
    <div @click="createVideo()" class="carousel-main-slide" :style="{ 'background': 'url(' + videos[currentVideoPointer]['poster'] + ')' }">
      <img :src="btnPlayUrl" alt="Odtwórz film" />
    </div>
    <div class="carousel-navigation">
      <a @click.prevent="previousSlide()" class="carousel-nav carousel-nav--left" href=""></a>
      <a @click.prevent="nextSlide()" class="carousel-nav carousel-nav--right" href=""></a>
      <span class="carousel-nav-numeric">
        {{ currentVideoNumber }} / {{ videos.length }}
      </span>
         <span class="carousel-actions">
      <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/playlist?list=PLufUAVXUjDY8r3_FnYr9HE0njvBLrMlBm">Zobacz wszystkie </a>
    </span>
    </div>
 
  </div>
</template>

<script>
export default {
  data () {
    return {
      uid: null,
      currentVideoPointer: 0
    }
  },
  methods: {
    nextSlide: function () {
      if (this.currentVideoPointer === this.videos.length - 1) {
        this.currentVideoPointer = 0
      } else {
        this.currentVideoPointer += 1
      }
    },
    previousSlide: function () {
      if (this.currentVideoPointer == 0) {
        this.currentVideoPointer = this.videos.length - 1
      } else {
        this.currentVideoPointer -= 1
      }
    },
    createVideo() {
        // dodaje globalną funkcję pozwalającą na dostęp do metod w komponencie
        window['vid_close_'+this.uid] = ()=>{
            this.destroyVideo()
            delete window['vid_close_'+this.uid]
        }

        var markup = [
            '<div id="vid_window_'+this.uid+'" v-if="opened" class="avc_page_overlay">',
            '    <button on="opened=false" onclick="vid_close_'+this.uid+'()" class="avc_close">',
            '        <svg width="1em" height="1em" viewBox="0 0 64 64">',
            '            <path id="backdrop" d="M32,26.104l26.104,-26.104l5.896,5.896l-26.104,26.104l26.104,26.104l-5.896,5.896l-26.104,-26.104l-26.104,26.104l-5.896,-5.896l26.104,-26.104l-26.104,-26.104l5.896,-5.896l26.104,26.104Z"></path>',
            '            <path d="M31.983,28.447l26.087,-26.087l3.57,3.57l-26.087,26.087l26.087,26.087l-3.536,3.536l-26.087,-26.087l-26.087,26.087l-3.57,-3.57l26.087,-26.087l-26.087,-26.087l3.536,-3.536l26.087,26.087Z" style="fill:#fff;"></path>',
            '        </svg>',
            '    </button>',
            '    <div class="avc_video_wrapper">',
            '        <div class="avc_video">',
            '            <iframe src="https://www.youtube.com/embed/'+ this.videos[this.currentVideoPointer].vid +'?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
            '        </div>',
            '    </div>',
            '</div>'
        ].join('\n');

        document.getElementById('last-container').innerHTML = markup
    },
    destroyVideo() {
      let container = document.getElementById('last-container')
      let video = document.getElementById('vid_window_'+this.uid)
      container.removeChild(video)
    }
  },
  computed: {
    currentVideo: function () {
      return this.videos[this.currentVideoPointer]
    },
    currentVideoNumber: function () {
      // todo count last 
      return this.currentVideoPointer + 1;
    },
    videos: function () {
      return window.pageContentData.params.videos
    },
    btnPlayUrl: function () {
      return window.pageContentData.params.images['btn-video-play']
    }
  },
  mounted(){
    this.uid = Math.random().toString(36).substr(2, 5);
  }
}
</script>

<style lang="scss" scoped>
  .carousel-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    .carousel-main-slide {
      position: relative;
      width: 100%;
      padding-top: 56.435%;
      min-height: 220px;
      // background-image: url('../../../assets/images/zpl/temp-video-poster.jpg');
      background-repeat: no-repeat !important;
      background-size: cover !important;
      border: 10px #fff solid;
      cursor: pointer;
      min-height: 220px;

      @media only screen and (max-width : 1024px) {
        width: 100%;
        padding-top: 56.29%;
        min-height: 180px;
      }

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        opacity: .7;

        -webkit-transform: translateX(-50%) translateY(-50%); 
        -moz-transform: translateX(-50%) translateY(-50%); 
        -ms-transform: translateX(-50%) translateY(-50%); 
        -o-transform: translateX(-50%)mtranslateY(-50%); 
        transform: translateX(-50%) translateY(-50%);

        -webkit-transition: all .2s ease-in-out;
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;

        border-radius: 99px;
        -webkit-box-shadow: 0px 0px 84px 54px rgba(0,0,0,0.2);
        -moz-box-shadow: 0px 0px 84px 54px rgba(0,0,0,0.2);
        box-shadow: 0px 0px 84px 54px rgba(0,0,0,0.2);
      }

      &:hover {
        img {
          opacity: .9;
        }
      }
    }

    .carousel-navigation {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;

      @media only screen and (max-width : 768px) {
        justify-content: center;
        padding-bottom: 1rem;
      }

      a.carousel-nav {
        width: 40px;
        height: 40px;
        display: inline-block;
        border: 2px rgb(181, 181, 181) solid;
        border-radius: 99px;
        margin-left: 1rem;
        position: relative;

        -webkit-transition: all .2s ease-in-out;
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;

        &:before {
          content: "";
          width: 10px;
          height: 2px;
          position: absolute;
          top: calc(50% + 2px);
          left: calc(50% - 6px);
          background: #e41429;

          transform: rotate(45deg);
        }

        &:after {
          content: "";
          width: 10px;
          height: 2px;
          position: absolute;
          top: calc(50% - 4px);
          left: calc(50% - 6px);
          background: #e41429;

          transform: rotate(-45deg);
        }

        &.carousel-nav--right {
          transform: rotate(180deg);
        }

        &:hover {
          background: rgba(181, 181, 181, .2);
        }
      }

      span.carousel-nav-numeric {
        display: inline-block;
        margin-left: 1.5rem;
      }
    }

    .carousel-actions {
      display: inline-block;
      // text-transform: uppercase;
      // font-size: 13px;
      // padding-left: 1.5rem;
      // font-weight: 600;
      // letter-spacing:0.84px ;
      // margin-top: 1rem;
      

      @media only screen and (max-width : 768px) {
        text-align: center;
      }
      
      a {
     
              color: #e41429;
              text-transform: uppercase;
               font-weight: 600;
                    font-size: 12px;
                       letter-spacing:0.84px ;
              align-self: flex-end;
              position: relative;
              margin-right: 20px;
              margin-top: 1.5rem;
               padding-left: 1.5rem;
                  &::after {
                content: "";
                position: absolute;
                top: 4px;
                right: -10px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 4px 0 4px 5px;
                border-color: transparent transparent transparent #e42429;
              }

        &:hover{
          text-decoration: none;
          color: darken(#e41429, 10%);
      
        }
      }
   
    }
  }
</style>
